import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useRef } from "react";
import withObservables from "@nozbe/with-observables";
import { UBButton } from "../../../../../Libraries";
import TransactionListingPage from "../../TransactionListing";
import ConsumerBillsListing from "../ConsumerBillsListing";
import { getCustomerOfBusiness } from "../../../../../database/helpers/customer";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import { LanguageContext } from "../../../../../context/LanguageContext";

const BILL_TXN_TYPES = ["bill_payment"];

const BillTransactionListing = ({ customers = [] }) => {
  const [I18n] = useContext(LanguageContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const billingContactsCacheRef = useRef(null);

  // L3: consumer bills for a specific company+consumer
  if (state?.consumerNumber) {
    return <ConsumerBillsListing />;
  }

  const customerPhone = state?.customerPhone || null;
  const customerName = state?.customerName || null;

  const payBillBtn = (
    <UBButton
      id="bill_txn_listing_pay_bill_btn"
      title={I18n.pay_bill}
      className="ubButtonStyle ubPrimaryButton textUppercase fontSize14"
      onClick={() => {
        triggerLogEvent(analytics, "w_bill_txn_pay_bill");
        navigate("/UCash/BillPayments", customerPhone ? {
          state: { prefilledCustomerName: customerName },
        } : undefined);
      }}
    />
  );

  return (
    <TransactionListingPage
      key={customerPhone || "__global__"}
      txnTypes={BILL_TXN_TYPES}
      title={I18n.bill_payments}
      customerPhone={customerPhone}
      customerName={customerName}
      contactDetailRoute="/UCash/BillTransactions"
      emptyRedirectRoute="/UCash/BillPayments"
      analyticsEvent="w_bill_txn"
      actionButton={payBillBtn}
      customers={customers}
      billingContactsCacheRef={customerPhone ? null : billingContactsCacheRef}
    />
  );
};

const enhance = withObservables([], () => ({
  customers: getCustomerOfBusiness(
    typeof window !== "undefined"
      ? localStorage.getItem("business_id") || ""
      : "",
  ),
}));

export default enhance(BillTransactionListing);
